import classNames from "classnames";
import dayjs from "dayjs";

import AscHeading from "../../AscTypography/AscHeading/AscHeading";
import { AscAdminActionOptionProps } from "../../AscAdminAction/AscAdminAction";

import AscTag from "../../AscTag/AscTag";
import styles from "./AscWorkshopCard.module.scss";
import AscAdminDropdown from "../../AscAdminDropdown/AscAdminDropdown";

export interface AscWorkshopCardProps {
  className?: string;
  imageUrl?: string;
  variant?: string;
  title: string;
  date?: string;
  time?: string;
  actions: AscAdminActionOptionProps[];
  color?: string;
}

export default function AscWorkshopCard({
  className,
  imageUrl,
  variant,
  title,
  date,
  time,
  actions,
  color = "#7b60fa",
}: AscWorkshopCardProps) {
  return (
    <div
      data-testid="asc-workshop-card"
      className={classNames(styles.ground, className)}
    >
      <div
        className={styles.imageGround}
        style={color ? { background: color } : {}}
      >
        {imageUrl && (
          <img src={imageUrl} alt={imageUrl} className={styles.image} />
        )}
        {variant && (
          <AscTag
            type="custom"
            color={color}
            label={variant}
            className={styles.variant}
          />
        )}
      </div>

      <div className={styles.titleContent}>
        <AscHeading className={styles.title} level={6}>
          {title}
        </AscHeading>
        <AscAdminDropdown alignment="right">
          {actions.map((el) => (
            <AscAdminDropdown.Option key={el.title} onClick={el.onClick}>
              {el.title}
            </AscAdminDropdown.Option>
          ))}
        </AscAdminDropdown>
      </div>
      {time && date && (
        <div className={styles.dateContent}>
          <span className={styles.dateLabel}>
            {`${dayjs(date).format("D MMMM[,] YYYY")} ${
              time ? "at " + dayjs(time).format("h:mm A") : ""
            }`}
          </span>
        </div>
      )}
    </div>
  );
}
